import Interceptor from "./Interceptor";

export default Interceptor;
